import React, { FC } from 'react'
import styles from 'styles/components/line.module.scss'

type Props = {
  height: number
  horizontalMargin: number
}

const VerticalLine: FC<Props> = (props) => {
  const { height, horizontalMargin } = props
  return <hr className={styles.vertical} style={{ height: height, margin: `0 ${horizontalMargin}px` }} />
}

export default VerticalLine
